<div class="page-break additional-charge" >

    <table style="width: 100%;" *ngIf="tableType !== 'ltl'">
        <tr class="header-area" style="height: 43px;">
            <div class="sub-title new-font-header" style="left: 0px;text-transform: uppercase;height: 40px;">{{tableData?tableData?.RateTableName:'Table Name'}}</div>
        </tr>
         <hr>
        </table>
        <br>
  
    <div class="addition-charge-area" *ngIf="tableType !== 'ltl'" style="justify-content: space-between;display: flex;" #additionCharge>
        <div class="agreement-area form-container" style="margin-right: 10px;">
            <div class="title new-font-size">Additional Charge</div>
            <table style="margin-bottom: 14px;" cellspacing="0" mat-table [dataSource]="chargesList">
                <tr class="accord-area new-font-size">
                    @for (i of ["charge","rate"]; track $index) {
                    <ng-container matColumnDef={{i}}>
                        <th mat-header-cell class="scrollable" style="background-color: #FFCC00;border: 1px solid #000;"
                            *matHeaderCellDef>
                            <div class="new-font-size" style="text-transform: capitalize;font-weight: bold;">{{i}}</div>
                        </th>
                        <td class="scrollable" mat-cell *matCellDef="let element; let ind=index"
                            style="border:1px solid #000">
                            <div class="new-font-size">{{element[i]}}</div>
                        </td>
                    </ng-container>
                    }
                </tr>
                <tr class="new-font-size" mat-header-row *matHeaderRowDef='["charge","rate"]'></tr>
                <tr class="new-font-size" mat-row *matRowDef='let row; columns: ["charge","rate"]'></tr>

            </table>
        </div>

        <div class="maunt-area form-container" style="margin-left: 10px;">
            <div class="title new-font-size">Maut</div>
            <table style="margin-bottom: 14px;" cellspacing="0" mat-table [dataSource]="mauntList">
                <tr class="accord-area new-font-size">
                    @for (i of ["country","rate"]; track $index) {

                    @if(i === "country"){
                    <ng-container matColumnDef={{i}}>
                        <th mat-header-cell class="scrollable key new-font-size" style="background-color: #FFCC00;border: 1px solid #000;" *matHeaderCellDef>
                            Country</th>
                        <td class="scrollable" mat-cell *matCellDef="let element;let ind=Index"
                            style="border:1px solid #000">
                            <span class="new-font-size">{{this.findCountryName(element[i])}}</span>
                        </td>
                    </ng-container>
                    }
                    @else {
                    <ng-container matColumnDef={{i}}>
                        <th mat-header-cell class="scrollable key new-font-size" style="background-color: #FFCC00;border: 1px solid #000;" *matHeaderCellDef>
                            Maut Kms</th>
                        <td class="scrollable" mat-cell *matCellDef="let element; let ind=index"
                            style="border: 1px solid #000;">
                            <div class="new-font-size">{{formatMautData(element[i])}}</div>
                        </td>
                    </ng-container>
                    }
                    }
                </tr>
                <tr class="new-font-size" mat-header-row *matHeaderRowDef='["country","rate"]'></tr>
                <tr class="new-font-size" mat-row *matRowDef="let row; columns: ['country','rate']"></tr>

            </table>
        </div>
    </div>
    
        <table class="remarks-table">
        <tr style="display: inline;">
            <div class="items" style="font-weight: bold;">REMARKS</div>
            <div *ngIf="tableType === 'ltl'"></div>
            <div class="remarks-content" [innerHTML]="getHtml(appService.deResingDoubleQuotess(tableData.Remarks))"></div>
        </tr>
    </table>

</div>